import { render } from "./AddressDetailsStats.vue?vue&type=template&id=2c4953dd"
import script from "./AddressDetailsStats.vue?vue&type=script&lang=js"
export * from "./AddressDetailsStats.vue?vue&type=script&lang=js"
script.render = render

export default script